module.exports = __webpack_public_path__ + "img/prize-04.90e9520f.png";